function downloadFile(file: BlobPart, name: string) {
  const url = window.URL.createObjectURL(new Blob([file]))
  const link = document.createElement('a')
  link.href = url
  link.download = name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const fileService = {
  downloadFile,
}
